// Ultimate Card Game (UCG) / VOID Conflict
// Legal Notice (Impressum § 5 DDG) and Privacy Policy (Datenschutz DSGVO) Modal (Fullscreen).

let activeOverlay = null;

function el(tag, className, text) {
  const node = document.createElement(tag);
  if (className) node.className = className;
  if (text !== undefined) node.textContent = text;
  return node;
}

export function showLegalModal(defaultTab = 'imprint', game = null) {
  const resolvedGame = game || (typeof window !== 'undefined' ? window.game : null);
  if (activeOverlay) {
    activeOverlay.remove();
    activeOverlay = null;
    resolvedGame?.overlayGate?.release?.();
  }
  resolvedGame?.overlayGate?.acquire?.();

  const layer = el('div', 'legal-overlay fullscreen-dialog-overlay');

  layer.innerHTML = `
    <div class="fullscreen-dialog-bg-layer" aria-hidden="true">
      <div class="fullscreen-dialog-bg-image"></div>
      <div class="fullscreen-dialog-scrim"></div>
      <div class="fullscreen-dialog-vignette"></div>
    </div>

    <div class="fullscreen-dialog-container">
      <header class="fullscreen-dialog-header">
        <div class="fullscreen-dialog-header-left">
          <div class="fullscreen-dialog-category">STATUTORY</div>
          <h2 class="fullscreen-dialog-title">DISCLOSURES</h2>
        </div>
        <div class="fullscreen-dialog-status-pill status-pill-circular" title="DSGVO // DDG COMPLIANT">
          <span class="status-indicator-dot"></span>
        </div>
      </header>

      <div class="fullscreen-dialog-body">
        <div class="fullscreen-card-panel" style="width: 100%; max-width: 860px; height: 100%; max-height: 560px; display: flex; flex-direction: column;">
          <div class="legal-tabs" style="margin-bottom: 12px; border-bottom: 1px solid rgba(0, 240, 255, 0.2); padding-bottom: 10px; display: flex; gap: 10px;">
            <button type="button" class="legal-tab-btn ${defaultTab === 'imprint' ? 'active' : ''}" id="tab-legal-imprint">
              Legal Notice (Impressum § 5 DDG)
            </button>
            <button type="button" class="legal-tab-btn ${defaultTab === 'privacy' ? 'active' : ''}" id="tab-legal-privacy">
              Privacy Policy (Datenschutz DSGVO)
            </button>
          </div>

          <div class="legal-content" id="legal-content-body" style="flex: 1; overflow-y: auto; padding-right: 12px;"></div>
        </div>
      </div>

      <footer class="fullscreen-dialog-footer">
        <button type="button" class="fullscreen-return-btn" id="legal-return-btn">
          <span class="start-btn-text">RETURN</span>
        </button>
      </footer>
    </div>
  `;

  const content = layer.querySelector('#legal-content-body');
  const tabImprint = layer.querySelector('#tab-legal-imprint');
  const tabPrivacy = layer.querySelector('#tab-legal-privacy');

  function renderImprint() {
    content.innerHTML = `
      <div class="legal-section" style="line-height: 1.6; font-family: 'Rajdhani', sans-serif; font-size: 13.5px; color: #cbd5e1;">
        <h3 style="font-family: 'Orbitron', sans-serif; font-size: 14px; color: #00f0ff; margin-bottom: 12px;">Information pursuant to § 5 DDG / Angaben gemäß § 5 DDG</h3>
        <p><strong>Operator & Service Provider / Diensteanbieter:</strong></p>
        <p style="margin-left: 12px;">
          Peter Paul Zernecke<br>
          Schwanthalerstr. 83<br>
          80336 München<br>
          Germany
        </p>
        
        <p><strong>Contact / Kontakt:</strong></p>
        <p style="margin-left: 12px;">Email: <a href="mailto:nais@betterbenais.com" style="color: #00f0ff;">nais@betterbenais.com</a></p>

        <p><strong>Dispute Resolution / Streitschlichtung:</strong></p>
        <p style="margin-left: 12px;">The European Commission provides a platform for online dispute resolution (ODR): <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" style="color: #00f0ff;">https://ec.europa.eu/consumers/odr</a>.<br>
        We are neither willing nor obligated to participate in dispute resolution proceedings before a consumer arbitration board.</p>

        <p><strong>Copyright & Intellectual Property:</strong></p>
        <p style="margin-left: 12px;">The content, source code, artwork, audio, and game systems created on this website are subject to German copyright law. Duplication, processing, distribution, or commercialization outside the limits of copyright requires prior written consent.</p>
      </div>
    `;
  }

  function renderPrivacy() {
    content.innerHTML = `
      <div class="legal-section" style="line-height: 1.6; font-family: 'Rajdhani', sans-serif; font-size: 13.5px; color: #cbd5e1;">
        <h3 style="font-family: 'Orbitron', sans-serif; font-size: 14px; color: #00f0ff; margin-bottom: 12px;">Privacy Policy (Datenschutzerklärung gem. DSGVO)</h3>
        
        <p><strong>1. 100% Tracking- and Cookie-Free Architecture</strong></p>
        <p style="margin-left: 12px;">VOID Conflict is committed to minimal data collection. We do <strong>not</strong> use tracking cookies, analytics scripts (such as Google Analytics), advertising trackers, or fingerprinting services. A cookie banner is not required because no consent-requiring cookies are stored.</p>

        <p><strong>2. Local Storage & Cross-Device Cloud Synchronization (100% Cookieless)</strong></p>
        <p style="margin-left: 12px;">Game progression, unlocked cards, built decks, and audio settings are stored in your browser's standard local storage (HTML5 StorageAdapter). To enable seamless cross-device play between smartphones, tablets, and desktop browsers, game states can be synchronized securely via our cloud persistence bridge using your anonymous Recovery Code (OCC Cloud Sync). No tracking cookies, session cookies, third-party analytics, or advertising identifiers are ever used.</p>

        <p><strong>3. Multiplayer & Online Identity</strong></p>
        <p style="margin-left: 12px;">When participating in online multiplayer matches, our game server processes:</p>
        <ul style="margin-left: 24px; color: #94a3b8;">
          <li>A pseudonymous <strong>Account ID</strong> and random secret token.</li>
          <li>Your self-chosen player name / Call-Sign.</li>
          <li>Match statistics and matchmaking rating (MMR).</li>
          <li>A cryptographic hash of your 12-character recovery code (the plaintext code is never stored on our servers).</li>
        </ul>

        <p><strong>4. Abuse Prevention & IP Rate Limiting</strong></p>
        <p style="margin-left: 12px;">To protect sensitive operations (such as account recovery) against automated brute-force attacks, IP addresses are processed in volatile memory as <strong>cryptographic, daily-rotating HMAC hashes</strong>. No permanent record linking your IP address to your personal identity is retained.</p>

        <p><strong>5. Your Rights Under GDPR</strong></p>
        <p style="margin-left: 12px;">You have the right to request information about your stored data, its correction, or deletion in accordance with GDPR Articles 15–20. Please contact our support email above for inquiries.</p>
      </div>
    `;
  }

  if (defaultTab === 'privacy') renderPrivacy();
  else renderImprint();

  tabImprint.addEventListener('click', () => {
    tabImprint.classList.add('active');
    tabPrivacy.classList.remove('active');
    renderImprint();
  });

  tabPrivacy.addEventListener('click', () => {
    tabPrivacy.classList.add('active');
    tabImprint.classList.remove('active');
    renderPrivacy();
  });

  // Close handlers
  const closeModal = () => {
    layer.remove();
    activeOverlay = null;
    resolvedGame?.overlayGate?.release?.();
    window.removeEventListener('keydown', handleKey);
  };

  const returnBtn = layer.querySelector('#legal-return-btn');
  returnBtn?.addEventListener('click', closeModal);

  const handleKey = (e) => {
    if (e.key === 'Escape') closeModal();
  };
  window.addEventListener('keydown', handleKey);

  document.body.appendChild(layer);
  activeOverlay = layer;
}
